/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Landing_Studio_Locked_PctInputs */

const en_landing_studio_locked_pct = /** @type {(inputs: Landing_Studio_Locked_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% of pixels locked`)
};

const zh_landing_studio_locked_pct = /** @type {(inputs: Landing_Studio_Locked_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% 的像素已锁定`)
};

/**
* | output |
* | --- |
* | "{pct}% of pixels locked" |
*
* @param {Landing_Studio_Locked_PctInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_locked_pct = /** @type {((inputs: Landing_Studio_Locked_PctInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Locked_PctInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_locked_pct(inputs)
	return zh_landing_studio_locked_pct(inputs)
});
export { landing_studio_locked_pct as "landing.studio.locked_pct" }